module.exports = __webpack_public_path__ + "5c9767837592232f92694321742e8e80.jpg";